import React from 'react'

export const Subcomponent = () => {
    return (
        <div>Subcomponent</div>
    )
}